import {BonusStatus} from "@/store/shop/types";
import {Tr} from "@/i18n/i18n";

export default class BonusPointUtils {

    public static getImageKey(status: BonusStatus): string {
        switch (status) {
            case BonusStatus.SILVER:
                return 'status_s';
            case BonusStatus.GOLD:
                return 'status_g';
            case BonusStatus.BRILLIANT:
                return 'status_b';
        }
        return 'status_b';
    }

    public static getStatusGenetive(status: BonusStatus): string {
        switch (status) {
            case BonusStatus.SILVER:
                return Tr('silv.gn');
            case BonusStatus.GOLD:
                return Tr('gld.gn');
            case BonusStatus.BRILLIANT:
                return Tr('brl.gn');
        }
        return Tr('brl.gn');
    }

    public static getStatusNominative(status: BonusStatus): string {
        switch (status) {
            case BonusStatus.SILVER:
                return Tr('silv.nm');
            case BonusStatus.GOLD:
                return Tr('gld.nm');
            case BonusStatus.BRILLIANT:
                return Tr('brl.nm');
        }
        return Tr('brl.nm');
    }

    public static getStatusPercent(status: BonusStatus): number {
        switch (status) {
            case BonusStatus.SILVER:
                return 10;
            case BonusStatus.GOLD:
                return 20;
            case BonusStatus.BRILLIANT:
                return 30;
        }
        return 30;
    }
}